import create from 'zustand'
import { AxiosRequestConfig } from 'axios'
import { ErrorResponse } from 'ts/types/ApiResponse'
import { http } from 'utils'

let pending = 0

type DataTableStore = {
  isLoading: boolean
  error: ErrorResponse | null
  data: {
    [key: string]: object[]
  }

  fetch: (
    key: string,
    url: string,
    config?: AxiosRequestConfig
  ) => Promise<void>

  reload: () => void
  setReload: (fn: () => void) => void
}

const useDataTableStore = create<DataTableStore>((set) => ({
  isLoading: true,
  error: null,
  data: {},

  fetch: async <T extends object>(
    key: string,
    url: string,
    config?: AxiosRequestConfig
  ) => {
    pending += 1
    set({ isLoading: true })

    try {
      const res = await http.get<T[]>(url, config)
      pending -= 1

      set((state) => ({
        isLoading: pending > 0,
        error: null,
        data: {
          ...state.data,
          [key]: res.data
        }
      }))
    } catch (error) {
      pending -= 1
      if (pending === 0) {
        set({ isLoading: false })
      }
    }
  },

  reload: () => {},
  setReload: (reload) => set({ reload })
}))

export default useDataTableStore
